import React, { Component } from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import withRouterActions from 'routes/utils/withRouterActions'
import { selectors as ApplicationsSelectors } from 'data/applications'

import { Item } from 'components/Utils/Menu/layout'
import RoutesHelper from 'helpers/RoutesHelper'

// This standalone component handles fetching integrations and selecting one
export class ConnectedIntegrationSelect extends Component {
  static propTypes = {
    // provided by enhancer:
    applicationsWithShareTo: PropTypes.array.isRequired,
  }

  render() {
    const { applicationsWithShareTo } = this.props

    if (applicationsWithShareTo.length === 0) {
      return null
    }

    const installed = applicationsWithShareTo.reduce((list, application) => {
      if (!application.isInstalled) {
        list = [...list, application.toJS()]
      }

      return list
    }, [])

    if (installed.length === 0) {
      return null
    }

    return installed.map(application => {
      const { id, photoURL, name } = application

      return (
        <Item
          key={id}
          action={() => {
            this.props.routerPush(
              RoutesHelper.settingsIntegrationApplicationDetails({
                applicationId: id,
                redirectUri: window.location.href,
              })
            )
          }}
        >
          <div className="flexbox flexbox-align-center">
            <img
              style={{ width: 16, height: 16 }}
              className="margin-right-normal"
              src={photoURL}
              alt={name}
            />
            <div className="no-break-word">{`Install the ${name} integration`}</div>
          </div>
        </Item>
      )
    })
  }
}

export default compose(
  withRouterActions,
  connect(function mapStateToProps(state) {
    return {
      applicationsWithShareTo: ApplicationsSelectors.getApplicationWithFeatures(
        state,
        ['shareTo']
      ),
    }
  })
)(ConnectedIntegrationSelect)
